import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTime } from 'luxon'
import * as React from 'react'
import controlStore from '../../../store/controlStore.ts'

interface Props {
    direction: 'older' | 'newer'
    reachedStart: boolean
    historyAvailable: number
    forwardTen: (e: any) => void
    backwardTen: (e: any) => void
    selectingDate: boolean
    date: DateTime
}

export const DateButton: React.FC<Props> = (props) => {
    const {direction, reachedStart, historyAvailable, forwardTen, backwardTen, selectingDate, date} = props
    
    const disabled = direction === 'older' ? historyAvailable < 10 || selectingDate : reachedStart || !historyAvailable || selectingDate
    const icon = direction === 'older' ? faChevronRight : faChevronLeft
    const isRight = direction === 'older'
    const dateTime = [date.toFormat(`EEE LLL dd`), date.toFormat('hh:mm a')]
    const isMobile = controlStore(s => s.isOnMobileDevice)
    
    const _back = (e: any) => {
        if (!disabled) {
            backwardTen(e)
        }
    }
    const _forward = (e: any) => {
        if (!disabled) {
            forwardTen(e)
        }
    }
    const onClick = direction === 'older' ? _back : _forward
    
    const dateLabel = isMobile ? (
        <div
            className={`flex flex-col justify-center text-lg bg-primary text-primary-content h-full p-2 ${!isRight ? 'rounded-l-none rounded-r-lg' : 'rounded-r-none rounded-l-lg'}`}>
            <div>{dateTime[0]}</div>
            <div>{dateTime[1]}</div>
        </div>
    ) : null
    
    const arrowButton = (
        <div
            className={`select-none flex flex-col h-[54px] justify-around bg-secondary p-2 ${!isRight ? 'rounded-l-xl' : 'rounded-r-xl'} min-w-12 p-1 hover:bg-secondary-focus ${disabled ? 'text-neutral-content/50' : 'text-primary-content'}`}
            style={{opacity: disabled ? 0.5 : 1}}>
            <FontAwesomeIcon icon={icon} size={'xl'}/>
            <div className={'text-sm'}>
                {direction.charAt(0).toUpperCase() + direction.slice(1)}
            </div>
        </div>
    )
    
    const button = (
        <div className={`select-none flex items-center h-[54px] my-1`} onClick={onClick}>
            {isRight ? dateLabel : arrowButton}
            {isRight ? arrowButton : dateLabel}
        </div>
    )
    
    return button
}
